var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { fallbackImage } from '../../../../images';
import { ButtonShowAllRewards, ContainerImageText, ErrorRefresh, LoadingSkeletonVertical, MessageNoData, RewardCardContainer, } from '../../../shared/rewards-hub';
import { useIsMobile } from '../../../../hooks';
import { rhGeneral } from '../../../../constants/RewardsHub';
import { ChallengesContext, InfoRewardsContext, RewardsAndOffersContext, } from '../../../../contexts';
import { rewardTileList } from '../../Drawer/RewardsDrawer/rewardTileList';
var useGetIsMobile = function () { return useIsMobile().isMobile; };
var assets = rhGeneral.assets;
var useCardProps = function () {
    var isChildAccount = React.useContext(RewardsAndOffersContext).isChildAccount;
    return {
        title: isChildAccount ? 'Company Rewards' : 'Rewards Available',
        faqTitle: 'Rewards',
        dataTestID: 'rewardsCard',
        headerUrl: rhGeneral.faqAnchor,
    };
};
export var NoDataStateRewards = function () {
    var isMobile = useGetIsMobile();
    var RewardImage = function () { return (React.createElement("div", null,
        React.createElement("img", { src: assets.ProXtraPerks, alt: "Offers", width: isMobile ? '45px' : '56px', height: isMobile ? '45px' : '56px', onError: fallbackImage }))); };
    return isMobile ? (React.createElement(ContainerImageText, { ImageComponent: RewardImage, dimensionsMW: "" },
        React.createElement(MessageNoData, { card: "Perks or offers" }))) : (React.createElement("div", { className: "sui-flex sui-gap-6 sui-pt-4 sui-pb-6" },
        React.createElement(RewardImage, null),
        React.createElement(MessageNoData, { card: "Perks or offers" })));
};
export var ErrorStateBoth = function () {
    var isMobile = useGetIsMobile();
    var refreshChallenges = React.useContext(ChallengesContext).refreshChallenges;
    var refreshRewards = React.useContext(InfoRewardsContext).refreshRewards;
    var cardProps = useCardProps();
    var refreshFunc = function () {
        refreshChallenges();
        refreshRewards();
    };
    var renderProps = __assign(__assign({}, cardProps), { noHeightLimit: true });
    var alertPaddingWorkaround = { marginBottom: '-16px' }; // TODO: until Stencil's fixed
    return (React.createElement(RewardCardContainer, __assign({ isMobile: isMobile }, renderProps),
        React.createElement("div", { className: "sui-flex sui-flex-col sui-mb-[-16px]", style: alertPaddingWorkaround },
            React.createElement(ErrorRefresh, { refreshFunc: refreshFunc, refreshWord: "Perks and offers" }))));
};
export var LoadingStateRewards = function () {
    var isMobile = useGetIsMobile();
    var cardProps = useCardProps();
    return (React.createElement(RewardCardContainer, __assign({ isMobile: isMobile }, cardProps),
        React.createElement(LoadingSkeletonVertical, { isMobile: isMobile })));
};
export var HasDataStateRewards = function (_a) {
    var _b;
    var rewardList = _a.rewardList;
    var isMobile = useGetIsMobile();
    var _c = React.useContext(ChallengesContext), isChallengeLoading = _c.isChallengeLoading, hasChallengeError = _c.hasChallengeError, refreshChallenges = _c.refreshChallenges;
    var _d = React.useContext(InfoRewardsContext), isLoadingRewards = _d.isLoading, hasRewardsError = _d.hasError, refreshRewards = _d.refreshRewards;
    var isReadyAndErrorFree = !isLoadingRewards &&
        !isChallengeLoading &&
        !hasChallengeError &&
        !hasRewardsError;
    var TILE_LIMIT = isMobile ? 5 : 2;
    var cardProps = useCardProps();
    var renderProps = __assign(__assign({}, cardProps), { noHeightLimit: !isChallengeLoading && !isLoadingRewards, itemAmount: isReadyAndErrorFree ? rewardList === null || rewardList === void 0 ? void 0 : rewardList.length : undefined, FooterButton: (rewardList === null || rewardList === void 0 ? void 0 : rewardList.length) > TILE_LIMIT ? ButtonShowAllRewards : undefined });
    var isListEmpty = (rewardList === null || rewardList === void 0 ? void 0 : rewardList.length) <= 0;
    return (React.createElement(RewardCardContainer, __assign({ isMobile: isMobile }, renderProps),
        hasChallengeError && (React.createElement(ErrorRefresh, { refreshFunc: refreshChallenges, refreshWord: "your offer" })),
        isListEmpty && !hasChallengeError && !hasRewardsError ? (React.createElement(NoDataStateRewards, null)) : ((_b = rewardTileList(rewardList, false, isMobile)) === null || _b === void 0 ? void 0 : _b.slice(0, TILE_LIMIT)),
        hasRewardsError && (React.createElement(ErrorRefresh, { refreshFunc: refreshRewards, refreshWord: "Perks and offers" }))));
};
